import { Joinus } from "../joinus/Joinus";
import { Footer } from "../footer/Footer";
import { Header } from "../../header/Header";
import { ServicesShowcaseChild } from "../service/ServicesShowcaseChild";
import '../aboutus/About.css';
import missionImage from "../../assets/mission.jpeg";

export const Child = () => {
    return (
        <div>
            <Header />
            <div className="about-us">
            <div className="about-header">
              <h1>Child Therapy</h1>
            </div>
            <div className="about-section">
                <img src={missionImage} alt="Mission" className="about-image" />
                <div className="about-text">
                  <p>
                    A lot of children are struggling with the emotional ,behavioral and developmental challenges without proper attention. A child therapy is designed in a specific manner so that the techniques may engage and support the child. it is typically for the children who are under the age of 18.
                    it also comprises managing their behavioural, emotional ,Social and sometimes cognitive aspects This therapy focuses on their hypersensitivity and their reactions as well. it is designed to address other aspects of children too for example school related difficulties ,learning related difficulties and IQ related difficulties. 
                  </p>
                </div>
            </div>
            </div>
            <ServicesShowcaseChild />
            <Joinus />
            <Footer/>
        </div>
    );
};